import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import "./style.css";
import CustomToast from "../../Components/CustomToast/CustomToast";

function DuplicateAuditsUi({
  columns,
  data,
  loading,
  onPageChange,
  tableQaury,
  totalRecords,
  setTableQaury,
  handleCopyAudits,
  handlecancel,
  cenData,
  auditId,
  toast
}) {
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);
   
  const lastCen = Array.isArray(cenData) && cenData[0]?.name;
  const secondLastCen =Array.isArray(cenData) && cenData[1]?.name;
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper duplicate">
            {/* Content Header (Page header) */}
            {/* <ContentHeader
              title={"Re-Audits"}
              buttonName={""}
              buttonBoolean={false}
              pageName={"Re-Audits"}
              linkPath={""}
            /> */}
            <div className="heading-div">
              <h3 className="heading">
                Copy Audits from {secondLastCen} to {lastCen}
              </h3>
              <p className="sub-heading">
                Select centers to copy their audit details to the new exam
                period
              </p>
            </div>
            {/* Main content */}
            <section className="content duplicate-content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                      {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                     <div className="mb-3">
                     <Search
                          setTableQaury={setTableQaury}
                          tableQaury={tableQaury}
                          placeHolder={"Search By Auditor"}
                        />
                     </div>
                        <Table
                          columns={columns}
                          data={data}
                          // loading={isLoading}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                          msg={`There are no approved audits available in the recent ${secondLastCen}.`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="duplicate-footer d-flex align-ietms-center justify-content-between">
                <div className="d-flex align-ietms-center">
                    <p className="mt-2 d-flex align-ietms-center ">{auditId?.length} centers selected</p>
                </div>
                <div>
                    {/* <button className="cancel-button" onClick={handlecancel}>Cancel</button> */}
                    <button className="blue-btn" onClick={handleCopyAudits}>Copy Audits</button>
                </div>
            </div>
          </div>
        </>
      )}

     
    </div>
  );
}

export default DuplicateAuditsUi;
